import List from 'list.js';

class PostsListCaseStudy {
	constructor(el) {
		this.el = el;
		this.page = this.el.classList.contains('block-work-grid') ? 6 : 12;
		this.pagination = true;
		this.caseStudyList = this.init();

		const filterServices = this.el.querySelector('#service');
		filterServices.addEventListener('change', (e) => {
			this.filterBy(this.caseStudyList, [
				{ itemName: 'cardServices', el: e.currentTarget.selectedOptions[0].value }
			]);
		});

		
		const loadMoreButton = this.el.querySelector('.load-more__button');

		loadMoreButton.addEventListener('click', () => {
			// Increment the current page and load the next page of items
			const nextPage = this.caseStudyList.page + this.page;
			this.caseStudyList.page = nextPage;
			
			this.caseStudyList.update();

			console.log(this.caseStudyList.visibleItems.length, this.caseStudyList.items.length)
			if (this.caseStudyList.visibleItems.length < this.caseStudyList.page) {
				this.el.querySelector('.load-more__button').classList.add('hide');
			} else {
				this.el.querySelector('.load-more__button').classList.remove('hide');
			}

		});
	}

	init() {
		const caseStudyList = new List(this.el, {
			valueNames: [
				'card-case-study__client-name',
				'card-case-study__title',
				{ name: 'cardServices', attr: 'data-services' }
			],
			page: this.page
		});

		return caseStudyList;
	}

	filterBy(list, criteria) {
		list.filter((item) => {
			let filter = [];
			criteria.forEach((criterion, key) => {
				filter[key] =
					criterion.el === 'all'
						? 0
						: item.values()[criterion.itemName].search(criterion.el);
			});

			if (filter[0] > -1) {
				return true;
			} else {
				return false;
			}
		});

		if (list.matchingItems.length === 0) {
			this.el.querySelector('.posts-list__no-results-container').classList.remove('hide');
		} else {
			this.el.querySelector('.posts-list__no-results-container').classList.add('hide');
		}

		console.log(list.matchingItems.length, this.caseStudyList.page)
		if (list.matchingItems.length <= this.caseStudyList.page) {
			this.el.querySelector('.load-more__button').classList.add('hide');
		} else {
			this.el.querySelector('.load-more__button').classList.remove('hide');
		}
	}
}

export default PostsListCaseStudy;
